<template>
  <el-dialog
    :close-on-click-modal="false"
    title="发票修改"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <span
        class="primary cur invoiceBtn"
        v-show="invoiceListData.length === 0"
        @click="addInvoice(0)"
      >添加</span>
      <qx-card-form
        :title="'发票' + (index + 1)"
        v-for="(item, index) in invoiceListData"
        :key="item.id"
      >
        <span slot="titleLeft">
          <span class="primary cur invoiceBtn" @click="addInvoice(index)">添加</span>
          <span class="error cur invoiceBtn" @click="delInvoice(index)">删除</span>
        </span>
        <InvoiceForm ref="invoiceForm" :invoice="item.invoice" :amount="item.amount" />
      </qx-card-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <qx-permpisions permpisions="">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </qx-permpisions>
      <qx-permpisions permpisions="">
        <el-button type="primary" @click="sub" :loading="subLoading || getDetailLoading">确 定</el-button>
      </qx-permpisions>
    </section>
  </el-dialog>
</template>

<script>
import {
  customerBillInvoiceList,
  customerBillInvoiceEdit,
} from 'api/getPay';
import InvoiceForm from './invoiceForm';
export default {
  components: {
    InvoiceForm,
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      originData: {},
      invoiceListData: [],
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    async show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.originData = item;
      this.getDetailLoading = true;
      const listRes = await customerBillInvoiceList({
        billNumber: item.billNumber,
      });
      this.getDetailLoading = false;
      if (!listRes.failed) {
        if (listRes.items.length === 0) {
          listRes.items = [{
            receiptNumber: '',
            amountDouble: '',
            id: Symbol('invoice'),
          }];
        }
        this.invoiceListData = listRes.items.map((item) => ({
          invoice: item.receiptNumber,
          amount: item.amountDouble,
          id: item.id,
        }));
      }
    },
    addInvoice (index) {
      this.invoiceListData.splice(index + 1, 0, {
        receiptNumber: '',
        amountDouble: '',
        id: Symbol('invoice'),
      });
    },
    delInvoice (index) {
      this.invoiceListData.splice(index, 1);
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      const invoiceList = [];
      const amountList = [];
      for (let i = 0; i < this.$refs.invoiceForm.length; i++) {
        const subData = await this.$refs.invoiceForm[i].sub();
        if (subData) {
          invoiceList.push(subData.invoice);
          amountList.push(subData.amount);
        } else {
          return;
        }
      }
      this.subLoading = true;
      const res = await customerBillInvoiceEdit({
        invoiceList: invoiceList.join(','),
        amountList: amountList.join(','),
        billNumber: this.originData.billNumber,
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.invoiceBtn {
  margin-left: 16px;
}
</style>
